
import { faHouseChimney } from '@fortawesome/free-solid-svg-icons'
import { faTreeCity } from '@fortawesome/free-solid-svg-icons'
import { faWrench } from '@fortawesome/free-solid-svg-icons'
import { faBriefcase } from '@fortawesome/free-solid-svg-icons'
import { faCircle } from '@fortawesome/free-solid-svg-icons'



export function getStationIcon(station) {

	const typeToIcon = {
		"indoor": faHouseChimney,
		"outdoor": faTreeCity,
		"service": faWrench,
		"portable": faBriefcase
	}

	if (station == null) 
		return faCircle

	if (station.service == true) 
		return typeToIcon["service"]

	return typeToIcon[station.type]
}

export function getStationIconElement(station) {
	const faIcon = getStationIcon(station)

	const svgElement = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
	svgElement.setAttribute('viewBox', `0 0 ${faIcon.icon[0]} ${faIcon.icon[1]}`);
	// svgElement.setAttribute('width', '1em');
	// svgElement.setAttribute('height', '1em');

	const pathElement = document.createElementNS('http://www.w3.org/2000/svg', 'path');
	pathElement.setAttribute('fill', 'currentColor');
	pathElement.setAttribute('d', faIcon.icon[4]);

	svgElement.appendChild(pathElement);

	return svgElement
}